export default __webpack_public_path__ + "static/media/folder-24.0cdd3905.jpeg";